<template>
  <v-container fluid>
    <v-row dense class="align-center mb-3">
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-select
          v-model="selectedFinancialYear"
          :items="yearList"
          label="Financial Year"
          dense
          outlined
          rounded
          hide-details
          class="fy-select-pill"
          @change="fetchOrganograms"
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-if="!loading">
      <v-col v-for="(org, index) in organograms" :key="index" cols="12">
        <v-card class="mb-4">
          <v-card-title class="d-flex justify-space-between align-center">
            <span>{{ org.division.name }} Division Organogram</span>
            <v-chip small color="primary" outlined>FY: {{ selectedFinancialYear }}</v-chip>
          </v-card-title>
          <v-card-text>
            <OrganogramFlow
              :employees="org.employees"
              :layout="org.layout"
              :isAdmin="false"
              :divisionName="org.division.name"
              :financialYear="selectedFinancialYear"
              :isPastYear="org.isPastYear"
              :hasSavedLayout="org.hasSavedLayout"
              :loggedInUserId="loggedInUserId"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-if="organograms.length === 0" cols="12">
        <v-alert type="info">No division assigned or organogram not available.</v-alert>
      </v-col>
    </v-row>
    <div v-else class="text-center py-5">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios';
import OrganogramFlow from '@/components/OrganogramFlow.vue';

export default {
  name: 'MyTeamOrganogram',
  components: {
    OrganogramFlow
  },
  data() {
    return {
      organograms: [],
      loading: true,
      loggedInUserId: null,
      selectedFinancialYear: null,
      yearList: []
    };
  },
  async created() {
    this.loggedInUserId = localStorage.getItem('userid');
    this.initFinancialYear();
    await this.fetchFinancialYears();
    await this.fetchOrganograms();
  },
  methods: {
    initFinancialYear() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      this.selectedFinancialYear = month < 3 ? `${year - 1}-${year}` : `${year}-${year + 1}`;
    },
    async fetchFinancialYears() {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get('/financialyear/getlist', {
          headers: { 'x-auth-token': token, token }
        });
        if (res.data && res.data.status && res.data.data) {
          this.yearList = res.data.data;
          if (!this.yearList.includes(this.selectedFinancialYear)) {
            this.yearList.unshift(this.selectedFinancialYear);
          }
        } else {
          this.yearList = [
            '2022-2023', '2023-2024', '2024-2025', '2025-2026', '2026-2027', '2027-2028', '2028-2029', '2029-2030'
          ];
        }
      } catch (e) {
        console.error("Error fetching financial years:", e);
        this.yearList = [
          '2022-2023', '2023-2024', '2024-2025', '2025-2026', '2026-2027', '2027-2028', '2028-2029', '2029-2030'
        ];
      }
    },
    async fetchOrganograms() {
      this.loading = true;
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get('/my-team/organogram', {
          params: { financialYear: this.selectedFinancialYear },
          headers: { 'x-auth-token': token }
        });
        if (res.data && res.data.status) {
          this.organograms = res.data.data;
        }
      } catch (e) {
        console.error("Error fetching organograms:", e);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.fy-select-pill >>> .v-input__control > .v-input__slot,
.fy-select-pill >>> .v-input__control > .v-input__slot fieldset,
.fy-select-pill >>> fieldset {
  border-radius: 28px !important;
}
</style>
